import { createSlice } from "@reduxjs/toolkit";
import { createApplication, deleteTest, getTests, updateTest } from "./Thunk";

export const test = createSlice({
  name: "test",
  initialState: {
    tests: [],
    isLoading: false,
    test: {
      isTest: true,
      isB2b: false,
      Name: "",
      Description: "",
      Duration: 60,
      scales: [],
      cleanScoringComp: false,
    },
    entityModal: {
      isShow: false,
      data: {
        name: "",
        description: "",
        duration: 0,
        scales: [],
        cleanScoringComp: false,
      },
    },
  },
  reducers: {
    updateTestLocally(state, action) {
      state.test[action.payload.key] = action.payload.value;
    },
    updateLeanApplication(state, action) {
      state.leanModal = action.payload;
    },
    openEntityModal(state, action) {
      state.entityModal.data = action.payload;
      state.entityModal.isShow = true;
    },
    updateEntityApplication(state, action) {
      state.entityModal.data = action.payload;
    },
    closeEntityModal(state) {
      state.entityModal.data = {};
      state.entityModal.isShow = false;
    },

    updateInfoApplication(state, action) {
      state.infoModal.application = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTests.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getTests.fulfilled, (state, action) => {
      state.tests = action.payload;
      state.isLoading = false;
      state.test = {
        isTest: true,
        isB2b: false,
        Name: "",
        Description: "",
        Duration: 60,
        scales: [],
        cleanScoringComp: false,
      };
    });
    builder.addCase(createApplication.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(createApplication.fulfilled, (state, action) => {
      state.tests = action.payload;
      state.test = {
        Description: "",
        Name: "",
        IsTest: true,
        IsB2b: false,
        scales: [],
        Duration: 60,
        cleanScoringComp: true,
      };
      state.isLoading = false;
    });

    builder.addCase(updateTest.fulfilled, (state, action) => {
      state.tests = action.payload;
    });
    builder.addCase(deleteTest.fulfilled, (state, action) => {
      state.tests = action.payload;
    });
  },
});

export const {
  updateTestLocally,
  closeEntityModal,
  openEntityModal,
  updateEntityApplication,
  updateLeanApplication,
  updateInfoApplication,
} = test.actions;

export default test.reducer;
